import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import style from './styles.module.css'
import {
  Bookmark,
  Bell,
  KeyRed,
  LogOut,
  Subtract,
  User,
  UserGroup,
} from '../../assets/svgs/icons'

const ACTIVE_COLOR = '#FF8B00'
const INACTIVE_COLOR = '#E6E6E6'
const MY_ACCOUNT_PATH = '/MyAccountPage'

const SideMenuMyAccount = ({ setStep = () => {}, step = -1 }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const pathname = location.pathname.toLowerCase()

  const isMyAccountPage = pathname === '/myaccountpage'
  const isSettingsPage = pathname === '/settings'
  const isUserListPage = pathname === '/userlist'

  useEffect(() => {
    if (!isMyAccountPage) return

    const guestUserId = window.localStorage.getItem('userData')
    if (!guestUserId) return

    try {
      const parsed = JSON.parse(guestUserId)
      if (parsed?.guestUserId) {
        setStep(1)
      }
    } catch {
      // ignore invalid localStorage payload
    }
  }, [isMyAccountPage, setStep])

  const getGuestUserId = () => {
    const guestUserId = window.localStorage.getItem('userData')
    if (!guestUserId) return null

    try {
      return JSON.parse(guestUserId)?.guestUserId ?? null
    } catch {
      return null
    }
  }

  const guestUserId = getGuestUserId()

  const getTextClass = (isActive) =>
    isActive ? style.navigation_text_selected : style.navigation_text

  const handleStepNavigate = (stepNumber, event) => {
    if (isMyAccountPage) {
      event.preventDefault()
      setStep(stepNumber)
    }
  }

  const renderMyAccountStepItem = (stepNumber, icon, label) => {
    const isActive = isMyAccountPage && step === stepNumber

    return (
      <li className={isActive ? style.selected : style.unselected}>
        <Link
          to={MY_ACCOUNT_PATH}
          state={{ step: stepNumber }}
          className={style.nav_link}
          onClick={(event) => handleStepNavigate(stepNumber, event)}
        >
          <div className={style.box_item_menu}>
            <div className={style.iconContainer}>{icon}</div>
            <p className={getTextClass(isActive)}>{label}</p>
          </div>
        </Link>
      </li>
    )
  }

  const renderRouteItem = (to, isActive, icon, label) => (
    <li className={isActive ? style.selected : style.unselected}>
      <Link to={to} className={style.nav_link}>
        <div className={style.box_item_menu}>
          <div className={style.iconContainer}>{icon}</div>
          <p className={getTextClass(isActive)}>{label}</p>
        </div>
      </Link>
    </li>
  )

  return (
    <div className={style.sidebar_expanded}>
      <div className={style.body_slidebar}>
        {guestUserId ? (
          <ul>
            {renderMyAccountStepItem(
              1,
              <KeyRed
                width="25"
                height="25"
                color={isMyAccountPage && step === 1 ? ACTIVE_COLOR : INACTIVE_COLOR}
              />,
              t('my_account.steps.access_data'),
            )}
          </ul>
        ) : (
          <ul>
            {renderMyAccountStepItem(
              0,
              <User
                width="25"
                height="25"
                color={isMyAccountPage && step === 0 ? ACTIVE_COLOR : INACTIVE_COLOR}
              />,
              t('my_account.steps.my_account'),
            )}

            {renderMyAccountStepItem(
              1,
              <KeyRed
                width="25"
                height="25"
                color={isMyAccountPage && step === 1 ? ACTIVE_COLOR : INACTIVE_COLOR}
              />,
              t('my_account.steps.access_data'),
            )}

            {renderMyAccountStepItem(
              2,
              <Bell
                color={isMyAccountPage && step === 2 ? ACTIVE_COLOR : INACTIVE_COLOR}
                width={25}
                height={25}
              />,
              t('my_account.steps.notifications'),
            )}

            {renderMyAccountStepItem(
              4,
              <Bookmark color={isMyAccountPage && step === 4 ? ACTIVE_COLOR : INACTIVE_COLOR} />,
              t('my_account.steps.social_media'),
            )}

            {renderRouteItem(
              '/Settings',
              isSettingsPage,
              <Subtract
                width="25"
                height="25"
                color={isSettingsPage ? ACTIVE_COLOR : INACTIVE_COLOR}
              />,
              t('side_menu.configurations'),
            )}

            {renderRouteItem(
              '/UserList',
              isUserListPage,
              <UserGroup
                size="25"
                color={isUserListPage ? ACTIVE_COLOR : INACTIVE_COLOR}
              />,
              t('side_menu.users'),
            )}
          </ul>
        )}
      </div>
      <div className={style.footer_slidebar}>
        <Link
          to={MY_ACCOUNT_PATH}
          state={{ step: 5 }}
          className={style.button_logout}
          onClick={(event) => handleStepNavigate(5, event)}
        >
          <LogOut color="#FF2F00" width="30px" height="30px" />
          {t('my_account.steps.logout')}
        </Link>
      </div>
    </div>
  )
}

export default SideMenuMyAccount
